export enum TipoPatologia {
    Patologías = 1,
    Estadosfisiologicos = 2,
    EstilosDeAlimentacion = 3,
    EstadosTiposDeDeporte = 4,
    ObjetivoTratamiento = 5,
}